export const breakpoints = {
  sm: '320px',
  md: '768px',
  lg: '992px',
  xl: '1200px',
  xxl: '1680px',
};

export const colors = {
  primary: '#b46547',
  secondary: '#333333',
  third: '#333333',
  fourth: '#C9D0D9',
  fifth: '#EEF0F3',
  bg: '#ffffff',
};

export const fonts = {
  primary: 'DeVinneEU-Normal, serif',
};

export default {
  breakpoints,
  colors,
  fonts,
};
